import React from "react";
import { Button } from "react-bootstrap";

import { IOrderProduct } from "@src/types/api";

interface Props {
    handleShow: () => void;
    status: IOrderProduct["status"];
}

const ProductManagementButtons = ({
    handleShow,
    status,
}: Props): React.JSX.Element => (
    <div>
        <Button type="button" variant="primary" onClick={handleShow}>
            {status === "cancelled"
                ? "Reinstate Registration"
                : "Cancel Registration"}
        </Button>
    </div>
);

export default ProductManagementButtons;
